import { useState, useMemo, useCallback } from 'react'

function useHover(initState = false) {
    const [hoveredState, changeHoveredState] = useState(initState)

    const resetHover = useCallback(() => changeHoveredState(false), [])

    const hoverEvents = useMemo(
        () => ({
            onMouseEnter: () => changeHoveredState(true),
            onMouseLeave: () => changeHoveredState(false),
        }),
        []
    )

    return [hoveredState, hoverEvents, resetHover] as const
}

export default useHover
